module.exports = __webpack_public_path__ + "img/hjhy@2x.b98d6f7d.png";